<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { Router, Route, Link, navigate } from "svelte-navigator";
    import { MDBBtn, MDBIcon } from "mdbsvelte";

    let liu = {
        fullname: "Admin",
    };

    const dispatch = createEventDispatcher();

    function handleMenu() {
        dispatch("handleMenu");
    }

    // console.log(handleMobileNav);
    onMount(() => {
        // liu = JSON.parse(window.sessionStorage);
    });

    const profile = () => {
        navigate("/profile");
    };
</script>

<main>
    <Router>
        <div class="menuCard ui grid">
            
            <div class="sideCol  sixteen wide column">
                <div class="proTitle">
                    <div class="" style="flex:1;">
                        <div
                            class="re three wide column"
                            style="text-align: right;"
                        >
                            <img
                                src="/assets/icons/stats.png"
                                alt="stats icon"
                                style="height: 1em;"
                            />
                        </div>
                    </div>

                    <div class="" style="flex: 12;padding:2px">
                        <span class="">
                            &nbsp;&nbsp; City<span class="rxName">Liquor</span>
                        </span>
                    </div>
                </div>

                <div class="profileBar">
                    <div class="ui grid" style="display:flex;">
                        <div class="re six wide column" style="flex:6;">
                            <div
                                class="profilevator"
                                style="text-align: right;"
                            >
                                <img
                                    src="/assets/images/user.png"
                                    alt="user icon"
                                    style="width: 100%;"
                                />
                            </div>
                        </div>

                        <div
                            class="yello ten wide column"
                            style="text-align: left;flex:10;"
                        >
                            <div class="profileDetails">
                                {#if liu != undefined}
                                    {liu.fullname} <br />

                                    <div class="" style="padding-top: 5px;">
                                        <button class="ui green basic mini fluid button">
                                           <i class="user icon"></i> Profile
                                        </button>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sideMenu">
                    <div class="column">
                        <Link on:click={handleMenu} to="admin/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="home" /> &nbsp;&nbsp;&nbsp; Home
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="/admin/sales/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="money-check-alt" /> &nbsp;&nbsp;&nbsp;
                                Sales
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="products/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="tags" /> &nbsp;&nbsp;&nbsp; Products
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="orders/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="tags" /> &nbsp;&nbsp;&nbsp; Orders
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="users/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="users" /> &nbsp;&nbsp;&nbsp; Users
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="offers/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="percentage" /> &nbsp;&nbsp;&nbsp;
                                Offers
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="analysis/">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="chart-line" /> &nbsp;&nbsp;&nbsp;
                                Analysis
                            </div>
                        </Link>
                    </div>

                    <div class="column">
                        <Link  on:click={handleMenu} to="">
                            <div class="mobileNavBar">
                                <MDBIcon fas icon="power-off" /> &nbsp;&nbsp;&nbsp;
                                Logout
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Router>
</main>

<style>
    .sideCol {
        background-color: #111111ab !important;
        border-radius: 1em !important;
        min-height: 80vh;
        margin: 1em;
        z-index: 100;
    }

    .profileBar {
        min-height: 2em;
        /* background: #35353583; */
        margin: 1em;
        padding: 1em;
    }

    .profilevator {
        background-color: #3d3d3d;
        padding: 0.4em;
        border-radius: 1em;
    }
    .profileDetails {
        padding-top: 1em;
        font-weight: 600;
        padding-left: 1em;
    }

    .sideMenu {
        margin: 1.3em;
    }

    .mobileNavBar {
        font-weight: 600;
        color: aliceblue;
        text-align: left;
        padding: 1em;
        color: rgb(1, 199, 140);
        border-radius: 0.5em;
        /* background: orange; */
    }

    .mobileNavBar:hover {
        background-color: rgba(1, 199, 149, 0.021);
        transition: 300ms;
    }

    .proTitle {
        display: none;
    }

    @media only screen and (min-width: 768px) {
        .proTitle {
            display: flex;
            font-weight: 600;
            font-size: 25px;
            text-align: left;
            padding: 0.4em;
            border-bottom: 1px solid rgba(128, 128, 128, 0.281);
        }

        .rxName {
            color: brown;
        }
    }
</style>
